// extracted by mini-css-extract-plugin
export default {"center":"PhysicalTake_center__vqH8U","ionCard":"PhysicalTake_ionCard__uEGC5","footer":"PhysicalTake_footer__fMZ+B","justifyContent":"PhysicalTake_justifyContent__eW6Hn"};